

















































import { Component } from 'vue-mixin-decorator';
import BaseView from '@/views/BaseView.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamGuide from '@/components/ExamGuide.vue';
import ExamNav from '@/components/ExamNav.vue';

import * as RouterPath from '@/classification/RouterPath';

import * as StringUtil from '@/common/StringUtil';
import * as Messages from '@/common/Messages';

import RepositoryFactory from '@/repository/RepositoryFactory';

@Component(
  {
    components: {
      'e-footer': ExamFooter,
      'e-guide': ExamGuide,
      'e-nav': ExamNav,
    },
  },
)
export default class UpdateMailConfirm extends BaseView {
  private AccountRepository = RepositoryFactory.get().account;

  private Messages = Messages;

  private token = '';

  private password = '';

  private isPasswordEmpty = false;

  private isFailedUpdate = false;

  private created() {
    const { token } = this.$route.query;
    if (StringUtil.isEmpty(token)) {
      this.$router.replace(RouterPath.TOP);
    }
    this.token = String(token);
  }

  private mounted() {
    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    const AccountCommonCss = document.createElement('link');
    AccountCommonCss.rel = 'stylesheet';
    AccountCommonCss.href = '/account/css/common.css';
    this.$el.appendChild(AccountCommonCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);
  }

  /**
   * メールアドレスを再設定します。
   */
  private resettingEmail() {
    this.isPasswordEmpty = false;
    this.isFailedUpdate = false;

    if (StringUtil.isEmpty(this.password)) {
      this.isPasswordEmpty = true;
      return;
    }

    try {
      this.AccountRepository.emailReset(this.token, this.password).then((response) => {
        if (response.status === 204) {
          this.$router.replace(RouterPath.UPDATE_MAIL_COMPLETE);
        }
        this.isFailedUpdate = true;
      }).catch(() => {
        this.isFailedUpdate = true;
      });
    } catch (e) {
      this.isFailedUpdate = true;
    }
  }
}
